import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BusinessType, UserTenantsDTO, RegisterUserWithTenantProvidersMappingDTO } from '@core/model/.';
import { environment } from '@env/environment';
import { ProviderAccountDTO } from '@mynexus/mynexus-ui-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  readonly baseUrl = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient) {}

  getTenants(): Observable<UserTenantsDTO> {
    return this.http.get<UserTenantsDTO>(`${this.baseUrl}/User/GetUserAndTenantsForRegistration`);
  }

  getProviderTypes(): Observable<BusinessType[]> {
    return this.http.get<any[]>(`${this.baseUrl}/Utilities/BusinessTypes`);
  }

  searchProviderByNpi(npi: string, tenantId: string): Observable<ProviderAccountDTO[]> {
    return this.http.get<ProviderAccountDTO[]>(
      `${this.baseUrl}/ProviderManagement/GetProviderAccounts_ByNpi/${npi}/${tenantId}`
    );
  }

  searchFacilityAccountsByNpi(npi: string, tenantId: string): Observable<ProviderAccountDTO[]> {
    return this.http.get<ProviderAccountDTO[]>(
      `${this.baseUrl}/ProviderManagement/GetFacilityAccounts_ByNpi/${npi}/${tenantId}`
    );
  }

  searchDmeProviderAccountsByNpi(npi: string, tenantId: string): Observable<ProviderAccountDTO[]> {
    return this.http.get<ProviderAccountDTO[]>(
      `${this.baseUrl}/ProviderManagement/GetDmeProviderAccounts_ByNpi/${npi}/${tenantId}`
    );
  }

  registerUserWithTenantProviders(payload: RegisterUserWithTenantProvidersMappingDTO, recaptchaToken: string): Observable<any> {
    let headers = new HttpHeaders().set('Authorization', `Recaptcha ${recaptchaToken}`);
    return this.http.post(`${this.baseUrl}/Users/CreateUserRegistrationProviders`, payload, { headers });
  }


  validateProviderTax(
    providerAccountId: string,
    taxId: string,
    tenantId: string
  ): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.baseUrl}/ProviderManagement/VerifyProviderTaxId/${providerAccountId}/${taxId}/${tenantId}`
    );
  }
}
